import script from "./DeveloperCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeveloperCard.vue?vue&type=script&setup=true&lang=ts"

import "./DeveloperCard.vue?vue&type=style&index=0&id=62b3ed1a&lang=css"

const __exports__ = script;

export default __exports__